<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div>
            <AutomationGeneralSettingsSection
                :automation="localAutomation"
                @onSuccess="handleAutomationUpdated($event.automation)"
            />

            <SideFormSectionDivider />

            <AutomationSectionTrigger
                :automation="localAutomation"
                :services="localServices"
                @onSuccess="handleAutomationUpdated($event.automation)"
            />

            <SideFormSectionDivider />

            <AutomationSectionAction
                :automation="localAutomation"
                @onSuccess="handleAutomationUpdated($event.automation)"
            />
        </div>

        <PageBottomPadding />
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import {
        type AutomationRawData,
        type PageMeta,
        type ServiceData,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import Automation from '@/App/Automation/Entity/Automation'
    import AutomationGeneralSettingsSection from '@/App/Automation/Component/AutomationGeneralSettingsSection.vue'
    import SideFormSectionDivider from '@/Shared/Component/SideFormSectionDivider.vue'
    import AutomationSectionTrigger from '@/App/Automation/Component/AutomationSectionTrigger.vue'
    import AutomationSectionAction from '@/App/Automation/Component/AutomationSectionAction.vue'
    import Service from '@/App/Service/Entity/Service'
    import PageBottomPadding from '@/Shared/Layout/App/Sidebar/PageBottomPadding.vue'

    interface IndexServicesProps {
        pageMeta: PageMeta
        appSharedDataRawData: any
        automationRawData: AutomationRawData
        servicesRawData: ServiceData[]
    }

    const props = defineProps<IndexServicesProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataRawData)
    const localAutomation = ref<Automation>(
        Automation.hydrateSingle(props.automationRawData),
    )
    const localServices = ref<Service[]>(
        Service.hydrateMultiple(props.servicesRawData),
    )

    const handleAutomationUpdated = (automation: Automation) => {
        localAutomation.value = automation
    }
</script>
